import { useEffect, useState } from 'react';
/**
 * Prefetches "how many graphs reference this id" so the Edit button on the
 * summary card can skip the deciding overlay instantly when the count is 0 or
 * 1. Re-runs when `referenceId` changes; cancels in-flight responses so a
 * fast swap doesn't apply a stale count.
 */
export function useUsagePrefetch(referenceId, onFetchUsageCount, shouldFetch = true) {
    const [count, setCount] = useState(null);
    useEffect(() => {
        setCount(null);
        if (!onFetchUsageCount || !shouldFetch)
            return;
        let cancelled = false;
        void (async () => {
            const next = await onFetchUsageCount(referenceId);
            if (!cancelled)
                setCount(next);
        })();
        return () => {
            cancelled = true;
        };
    }, [referenceId, onFetchUsageCount, shouldFetch]);
    return { count, setCount };
}
//# sourceMappingURL=use-usage-prefetch.js.map